import { TYPES } from '../render/constants';
import { Action } from './action';

function condition() {
  return true;
}

function selectAll(stageContext) {
  const nodes = stageContext.api.getSelectedNodes();
  if (!nodes.length) {
    const topNodes = stageContext.api.getNodes().filter((node) => !node.parentId);
    stageContext.api.selectNode(topNodes.map((n) => n.id));
  } else if (nodes.length === 1 && nodes[0].type === TYPES.frame) {
    const children = stageContext.api.getChildren(nodes[0].id);
    stageContext.api.selectNode(children.map((n) => n.id));
  }
}

export const selectAllAction = new Action({
  name: 'selectAll',
  handler: selectAll,
  shortcuts: 'Ctrl+A',
  condition: condition,
});
